module.exports = __webpack_public_path__ + "static/media/agency-icon.5566e018.svg";